require('popper.js/dist/umd/popper.js');
require('bootstrap');

window.axios = require('axios');

require('./scss/vendor.scss');

//require('bootstrap/dist/css/bootstrap.min.css'); // INFO: use here to split into a vendor.min.css file or use in _master-styles.scss to bundle w/ my code

let outdatedBrowserRework = require('outdated-browser-rework');

jQuery(document).ready(function() {
    outdatedBrowserRework();
});